export enum dateSettings {
  UTC = 'UTC',
}
